import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Box, Collapse, Flex, UnstyledButton } from '@mantine/core';
import { MyIcon } from '@web/common-ui';
import { useNachversandStore } from '../../../../../../store/NachversandStore';
import { WARNING_COLOR } from '../../../waiting-phase/NachversandBanner';
import { NACHVERSAND_GREEN } from '../../../versand/utils';
import { Part2AppointmentDetails } from '../../../versand/components';
import { getNachversandHomeBannerState } from './nachversandHomeBannerState';
import { NachversandHomeBannerTitle } from './NachversandHomeBannerTitle';
import { MissedBannerContent } from './MissedBannerContent';

const COLLAPSE_ID = 'nachversand-home-collapse';

/**
 * Part 2 Nachversand on the home screen, only when there is something to do: the booked call,
 * or a missed one for seven days (getNachversandHomeBannerState). Everything else lives in the
 * "Versand" tab.
 */
export const NachversandHomeBanner = observer(() => {
  const [expanded, setExpanded] = useState(true);
  const store = useNachversandStore();

  useEffect(() => store.loadAndReloadOnVisible(), [store]);

  const state = getNachversandHomeBannerState(store.nachversand);
  const current = store.nachversand?.current;
  if (state === null || !current) {
    return null;
  }

  const missed = state === 'MISSED';
  const accentColor = missed ? WARNING_COLOR : NACHVERSAND_GREEN;

  return (
    <Box
      py={12}
      px={16}
      style={{ border: `2px solid ${accentColor}`, borderRadius: 8 }}
    >
      <UnstyledButton
        onClick={() => setExpanded((prev) => !prev)}
        w="100%"
        type="button"
        aria-expanded={expanded}
        aria-controls={COLLAPSE_ID}
      >
        <Flex justify="space-between" align="center" gap="12px">
          <NachversandHomeBannerTitle
            appointment={current.appointment}
            missed={missed}
          />
          <MyIcon
            name={expanded ? 'arrow_up' : 'arrow_down'}
            style={{ flexShrink: 0, display: 'block' }}
          />
        </Flex>
      </UnstyledButton>

      <Collapse in={expanded} id={COLLAPSE_ID}>
        <Flex direction="column" gap="16px" pt="12px">
          {missed ? (
            <MissedBannerContent appointment={current.appointment} />
          ) : (
            <Part2AppointmentDetails appointment={current.appointment} />
          )}
        </Flex>
      </Collapse>
    </Box>
  );
});
